export default __webpack_public_path__ + "media/zurb/img/events/wired/raft/raft-photos-4b2aa75b7f57b180b93b0921a1d9e7b5.png";